module.exports = __webpack_public_path__ + "static/media/twitter_icon.8f662cde.svg";